module.exports = __webpack_public_path__ + "static/media/ao.4ad59271.svg";